import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function DischargeIcon(props) {
  return (
    <SvgIcon viewBox="0 0 18 18" {...props}>
      <g clipPath="url(#clip0_1427_49825)">
        <path
          d="M5.25781 4.54665L5.25781 15.0875C5.25781 15.9496 5.95668 16.6484 6.81878 16.6484L11.348 16.6484C12.2101 16.6484 12.909 15.9496 12.909 15.0875L12.909 4.54665C12.909 3.68455 12.2101 2.98568 11.348 2.98568L6.81878 2.98568C5.95668 2.98568 5.25781 3.68455 5.25781 4.54665Z"
          stroke="currentColor"
          fill="none"
          strokeWidth="1.09302"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M6.96875 11.7525L6.96875 14.6853C6.96875 14.7081 7.03498 14.7266 7.11668 14.7266L11.0421 14.7266C11.1238 14.7266 11.1901 14.7081 11.1901 14.6853L11.1901 11.7525C11.1901 11.7298 11.1238 11.7113 11.0421 11.7113L7.11668 11.7113C7.03498 11.7113 6.96875 11.7298 6.96875 11.7525Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.09302"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M7.80469 1.34375L10.3548 1.34375"
          stroke="currentColor"
          fill="none"
          strokeWidth="1.09302"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1427_49825">
          <rect
            width="17.4883"
            height="17.4883"
            transform="translate(0.335938 17.7422) rotate(-90)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default DischargeIcon;
